/* eslint-disable */
import {
    greenThemeLight, greenThemeDark, lightGreenThemeDark, brownThemeDark, bwThemeLight, bwThemeDark, blueThemeLight, blueThemeDark, redThemeLight, redThemeDark, orangeThemeLight, orangeThemeDark, purpleThemeLight, purpleThemeDark, pinkThemeLight, pinkThemeDark, yellowThemeLight, yellowThemeDark
} from '../theme/theme'


export const themeData = {
    theme: yellowThemeDark
}


// Choose theme from above